import toast from "react-hot-toast";
import api from "../Crypto/axios.js";

export const PLACED_ORDER = "PLACED_ORDER";
export const SELLER_ORDERS = "SELLER_ORDERS";
export const SELLER_ORDERS_BY_ID = "SELLER_ORDERS_BY_ID";
export const UPDATE_ORDER_STATUS = "UPDATE_ORDER_STATUS";

const initialState = {
  placedOrder: [],
  sellerOrders: [],
  sellerOrdersById: [],
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case PLACED_ORDER:
      return {
        ...state,
        placedOrder: action.payload,
      };
    case SELLER_ORDERS:
      return {
        ...state,
        sellerOrders: action.payload,
      };
    case SELLER_ORDERS_BY_ID:
      return {
        ...state,
        sellerOrdersById: action.payload,
      };
    case UPDATE_ORDER_STATUS:
      return {
        ...state,
        sellerOrdersById: {
          ...state.sellerOrdersById,
          orders: {
            ...state.sellerOrdersById.orders,
            status: action.payload.status, // update only status
          },
        },
      };

    default:
      return state;
  }
};

export default orderReducer;

export const fetchPlacedOrder = (data) => ({
  type: PLACED_ORDER,
  payload: data,
});

export const fetchSellerOrder = (data) => ({
  type: SELLER_ORDERS,
  payload: data,
});

export const fetchSellerOrderById = (data) => ({
  type: SELLER_ORDERS_BY_ID,
  payload: data,
});

export const updateOrderStatusAction = (status) => ({
  type: UPDATE_ORDER_STATUS,
  payload: { status },
});

export const placeOrder = (newOrder) => {
  return async (dispatch) => {
    const promise = api
      .post("/nrcb/ecom/add/order/product/", newOrder, { requiresAuth: true })
      .then((response) => {
        dispatch(fetchPlacedOrder(response));
        return response;
      })
      .catch((error) => {
        console.error("Error placing order:", error);
        throw new Error(
          error?.response?.data?.message || "Failed to place order"
        );
      });

    toast.promise(promise, {
      loading: "Placing order...",
      success: "Order placed successfully!",
      error: (error) => error.message || "Failed to place order",
    });

    return promise;
  };
};

export const getSellerOrders = (userId) => {
  return async (dispatch) => {
    const promise = api
      .get(`/nrcb/ecom/get/order/product/seller/${userId}`, {
        requiresAuth: true,
      })
      .then((response) => {
        dispatch(fetchSellerOrder(response.orders));
        return response;
      });
    return promise.catch((error) => {
      return {
        status: "error",
        message: error.response?.data?.message || "Failed to fetch orders",
      };
    });
  };
};

export const getSellerOrdersById = (userId, sellerId) => {
  return async (dispatch) => {
    const promise = api
      .get(`/nrcb/ecom/get/orderbyid/product/seller/${userId}/${sellerId}`, {
        requiresAuth: true,
      })
      .then((response) => {
        dispatch(fetchSellerOrderById(response));
        return response;
      });
    return promise.catch(() => {
      return { status: "error", message: "Failed to fetch seller orders" };
    });
  };
};

export const updateOrderStatus = (orderId, sellerId, data) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/update/order/status/${orderId}/${sellerId}`, data, {
        requiresAuth: true,
      })
      .then((response) => {
        const updatedProducts =
          response.data?.products || response.orders?.products || [];
        const sellerProduct = updatedProducts.find(
          (p) => p.sellerId === sellerId
        );

        if (sellerProduct?.status) {
          dispatch(updateOrderStatusAction(sellerProduct.status));
        }

        return response;
      })

      .catch((error) => {
        console.error("Error updating order status:", error);
        throw new Error(
          error?.response?.message || "Failed to update order status"
        );
      });

    toast.promise(promise, {
      loading: "Updating order status...",
      success: "Order status updated!",
      error: (error) => error.message || "Failed to update order status",
    });

    return promise;
  };
};


export const requestProductReturn = (productId, returnStatus,cancelledStatus, cancelledReason, userId, sellerId) => {
  return async (dispatch) => {
    try {
      await api.post(
        `/nrcb/ecom/return/product/${productId}`,
        { returnStatus, cancelledReason,cancelledStatus },
        { requiresAuth: true }   // ✅ correct place for config
      );

      // Optionally refresh seller orders
      dispatch(getSellerOrdersById(userId, sellerId));

      toast.success("Return requested successfully!");
    } catch (err) {
      toast.error("Failed to request return.");
      console.error(err);
    }
  };
};


const loadPaynimoScript = () => {
  return new Promise((resolve, reject) => {
    if (window.$ && window.$.pnCheckout) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src =
      "https://www.paynimo.com/paynimocheckout/server/lib/checkout.js";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Paynimo script"));
    document.body.appendChild(script);
  });
};

export const initiatePayment = (amount, consumerId, orderDetails) => {
  return async (dispatch) => {
    try {
      await loadPaynimoScript();
      const response = await api.post("/nrcb/ecom/initiate-payment", {
        amount,
        consumerId,
        orderDetails,
      });
      response.consumerData.responseHandler = async function (res) {
        if (res?.paymentMethod?.paymentTransaction?.statusCode === "0300") {
          console.log("Payment Success");
          dispatch({ type: "PAYMENT_SUCCESS", payload: res });
        } else if (
          res?.paymentMethod?.paymentTransaction?.statusCode === "0398"
        ) {
          console.log("Payment Initiated");
          dispatch({ type: "PAYMENT_PENDING", payload: res });
        } else {
          console.log("Payment Failed");
          dispatch({ type: "PAYMENT_FAILED", payload: res });
        }
        try {
          await api.post("/nrcb/ecom/payment-status", res);
        } catch (verifyErr) {
          console.error(
            "Payment status verification failed:",
            verifyErr.message
          );
        }
      };
      window.$.pnCheckout(response);
    } catch (err) {
      console.error("Payment initiation failed:", err.message);
      dispatch({ type: "PAYMENT_ERROR", payload: err.message });
    }
  };
};
